import {
  createContext,
  useContext,
  useState,
  ReactNode,
  useEffect,
} from 'react'
import toast from 'react-hot-toast'
import { api } from '../../services/api'
import { useAuth } from '../Auth/AuthContext'
import { v4 as uuid } from 'uuid'
import axios from 'axios'

interface RequestProvidersProps {
  children: ReactNode
}

interface Cart {
  id: string
  name: string
  category: string
  price: number
  img: string
  description?: string
  quantityStock: number
  quantidade: number
  userId: number
}

interface User {
  email: string
  id: number
  name: string
  address: string
  admin: boolean
}

interface Orders {
  id: string
  price: number
  details: Cart[]
  user: User
  status: string
  payment: string
}

interface Rating {
  id?: string
  userId: number
  stars?: number
  review?: string
  idRequest?: string
  nameUser?: string
}

interface RequestProviderData {
  request: Orders[]
  requestUser: Orders[]
  finishRequest: (cart: Cart[], price: number, payment: string) => void
  toPayment: (cart: Cart[]) => void
  updateRequest: (orderRequest: Orders) => void
  createRating: (data: Rating) => void
  getRequest: () => void
  getRating: () => void
  rating: Rating[]
}

interface SerializedProduct {
  title: string
  id: string
  // category_id: string
  description?: string
  quantity: number
  picture_url: string
  currency_id: string
  unit_price: number
}

const RequestContext = createContext<RequestProviderData>(
  {} as RequestProviderData
)

export const RequestProvider = ({ children }: RequestProvidersProps) => {
  const [request, setRequest] = useState<Orders[]>([])
  const [rating, setRating] = useState<Rating[]>([])
  const [requestUser, setRequestUser] = useState<Orders[]>([])
  const { user, accessToken } = useAuth()
  const [refresh, setRefresh] = useState(false)
  const [orderId, setOrderId] = useState("")

  function finishRequest(cart: Cart[], price: number, payment: string) {
    console.log(payment)
    const order = {
      ...{
        user: user,
        id: uuid(),
        price: price,
        payment: payment,
        status: 'Aguardando aceitação',
        details: cart,
      },
    }
    api
      .post(`/orders`, {}, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((response) => {
        // toast.success('Pedido realizado!')
        setOrderId(response.data.id)
        setRequest([...request, response.data])
        setRefresh(!refresh)

        if (payment !== 'Dinheiro') {
          let serializedProducts = []

          for (let i = 0; i < cart.length; i++) {
            const serializedProduct: SerializedProduct = {
              title: cart[i].name,
              id: cart[i].id,
              description: cart[i].description,
              // category_id: user.id.toString(),
              quantity: cart[i].quantidade,
              picture_url: cart[i].img,
              currency_id: 'BRL',
              unit_price: cart[i].price,
            }
            serializedProducts.push(serializedProduct)
          }
      
          const serializedOrder = {
            notification_url: 'https://capstone-sushizera.herokuapp.com/payments/mercadopago',
            // notification_url: 'https://hookb.in/Drqr0qK6WJHM1WNyXyNZ',
            items: serializedProducts,
            external_reference: response.data.id
          }
      
          console.log(response.data.id)
      
          axios
            .post(
              'https://api.mercadopago.com/checkout/preferences?access_token=TEST-151680122378677-050214-045dac335f81f9aa810e3d673f7e6a4f-6124851',
              serializedOrder
            )
            .then((response) => window.open(response.data.init_point))
        }


      })
      .catch((err) => {
        setRefresh(!refresh)
      })

  }

  function toPayment(cart: Cart[]) {
   
  }

  const updateRequest = (orderUpdate: Orders) => {
    api
      .patch(`/orders/${orderUpdate.id}`, orderUpdate, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((response) => {
        setRequest([...request])
        setRefresh(!refresh)
      })
      .catch((err) => {
        setRefresh(!refresh)
      })
  }

  const createRating = (data: Rating) => {
    api
      .post(`/rating/`, data, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((response) => {
        toast.success('Obrigada pelo feedback!')
        setRating([...rating, response.data])
      })
      .catch((err) => {
        setRefresh(!refresh)
      })
  }

  const getRequest = () => {
    api
      .get(`/orders`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((response) => {
        setRequest(response.data)
        setRefresh(!refresh)
        setRequestUser(
          response.data.filter((item: Orders) => item.user.id === user.id)
        )
      })
      .catch()
  }

  const getRating = () => {
    api
      .get(`/rating`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((response) => {
        setRating(response.data)
        setRefresh(!refresh)
      })
      .catch()
  }

  useEffect(() => {
    api
      .get(`/orders`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((response) => {
        setRequest(response.data)
        setRequestUser(
          response.data.filter((item: Orders) => item.user.id === user.id)
        )
      })
      .catch()
  }, [requestUser.length])

  useEffect(() => {
    api
      .get(`/orders`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((response) => {
        setRequest(response.data)
        setRequestUser(
          response.data.filter((item: Orders) => item.user.id === user.id)
        )
      })
      .catch()
  }, [refresh])

  useEffect(() => {
    api
      .get(`/rating`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((response) => {
        setRating(response.data)
      })
      .catch()
  }, [refresh])

  useEffect(() => {
    api
      .get(`/rating`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((response) => {
        setRating(response.data)
      })
      .catch()
  }, [rating.length])

  return (
    <RequestContext.Provider
      value={{
        getRating,
        getRequest,
        rating,
        createRating,
        request,
        requestUser,
        finishRequest,
        updateRequest,
        toPayment,
      }}
    >
      {children}
    </RequestContext.Provider>
  )
}

export const useRequest = () => useContext(RequestContext)
